import { render, staticRenderFns } from "./PositionInvite.vue?vue&type=template&id=a30c6784&"
import script from "./PositionInvite.vue?vue&type=script&lang=js&"
export * from "./PositionInvite.vue?vue&type=script&lang=js&"
import style0 from "./PositionInvite.vue?vue&type=style&index=0&id=a30c6784&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports